import { useSelector } from 'react-redux';

import type RootState from 'store/state';

type Output = {
    isMonitoring: boolean;
    isBarging: boolean;
    isMonitoringOrBarging: boolean;
    isEnhancedMonitoringEnabled: boolean;
};

const defaultOutput: Output = {
    isMonitoring: false,
    isBarging: false,
    isMonitoringOrBarging: false,
    isEnhancedMonitoringEnabled: false,
};

export default function useMonitoring(): Output {
    const monitorInfo = useSelector((state: RootState) => state.call?.monitorInfo);

    if (!monitorInfo) return defaultOutput;

    const { status, isEnhancedMonitoringEnabled } = monitorInfo;

    const isMonitoringOrBarging = !!status;

    const isMonitoring = status === 'SILENT_MONITOR';
    const isBarging = status === 'BARGE';

    return { isMonitoring, isBarging, isMonitoringOrBarging, isEnhancedMonitoringEnabled };
}
